<template>
  <v-container class="pa-0 ma-0 d-flex flex-column">
    <!-- Row 1 -->
    <v-row class="ma-0 pa-0">
      <v-col
        v-for="(item, index) in row1"
        :key="'row1-' + index"
        cols="12"
        sm="6"
        md="3"
        :class="['pa-2', index === 0 && 'pr-0', index === row1.length - 1 && 'pl-0']"
      >
        <v-card
          outlined
          :style="getIconName(item.title).bgColor"
          class="stat-cards pa-3 ma-0 d-flex flex-column"
        >
          <!-- title + icon -->
          <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
            <v-container class="pa-0 ma-0 d-flex flex-column">
              <v-card-text class="pa-0 ma-0 text-body-1">
                {{ item.title }}
              </v-card-text>
              <v-card-text class="pa-0 ma-0 text-body-2">
                {{ item.value }}
                <span v-if="index == 1 || index == 3">
                  {{ $t("numbers") }}
                </span>
                <span v-else>
                  {{ $store.state.currency.name }}
                </span>
              </v-card-text>
            </v-container>

            <v-sheet
              width="28"
              height="28"
              :color="getIconName(item.title).bgIcon"
              class="d-flex align-center justify-center"
            >
              <my-icon
                :name="getIconName(item.title).name"
                :width="14"
                :height="14"
                :stroke="getIconName(item.title).color"
                :fill="getIconName(item.title).color"
              />
            </v-sheet>
          </v-container>

          <!-- percent -->
          <v-container class="pa-0 ma-0 d-flex align-center mt-2">
            <v-icon size="14" :color="getPercentColor(item.trend)">
              {{ getPercentIcon(item.trend) }}
            </v-icon>

            <v-card-text
              class="pa-0 ma-0 pl-2 text-body-2"
              :style="{ color: getPercentColor(item.trend) }"
            >
              {{ item.percent }}٪
            </v-card-text>

            <v-card-text class="pa-0 ma-0 text-body-2">
              {{ item.compare }}
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

export default {
  name: "DashboardStats",
  components: { MyIcon },

  props: {
    warehouseData: {
      type: Object,
      required: true,
    },
    totalStock: {
      type: Number,
      required: true,
    },
    duration: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    stats() {
      return [
        {
          title: this.$t("total_inventory_value"),
          value: this.formatNumber(this.warehouseData?.current?.total_balance_value ?? 0),
          percent: this.warehouseData?.current?.diffPercent ?? 0,
          trend: this.warehouseData?.current.trend ?? "none",
          compare: this.duration ? this.$t("duration") : this.$t("month_compare"),
        },
        {
          title: this.$t("low_stock_items"),
          value: this.totalStock ?? 0,
          percent: 0,
          trend: "none",
          compare: this.duration ? this.$t("duration") : this.$t("month_compare"),
        },
        {
          title: this.$t("inventory_turnover"),
          value: this.formatNumber(this.warehouseData?.current ?? 0),
          percent: this.warehouseData?.current?.diffPercent ?? 0,
          trend: this.warehouseData?.current?.trend ?? "none",
          compare: this.duration ? this.$t("duration") : this.$t("month_compare"),
        },
        {
          title: this.$t("total_items_count"),
          value: this.warehouseData?.current?.total_balance_count ?? 0,
          percent: this.warehouseData?.current?.diffPercent ?? 0,
          trend: this.warehouseData?.current?.trend ?? "none",
          compare: this.duration ? this.$t("duration") : this.$t("month_compare"),
        },
      ];
    },

    row1() {
      return this.stats.slice(0, 4);
    },

    // row2() {
    //   return this.stats.slice(4, 8);
    // },
  },

  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) return "-";
      return this.$numberFormat(value);
    },

    getIconName(title) {
      const map = {
        [this.$t("total_inventory_value")]: {
          name: "cube-icon",
          bgIcon: "#155DFC",
          color: "#fff",
          bgColor: { backgroundColor: "#2b80ff24" },
        },
        [this.$t("low_stock_items")]: {
          name: "circle-alert-outline",
          bgIcon: "#E7000B",
          color: "#fff",
          bgColor: { backgroundColor: "#fb2c3653" },
        },
        [this.$t("inventory_turnover")]: {
          name: "arrow-up",
          bgIcon: "#00A63E",
          color: "#fff",
          bgColor: { backgroundColor: "#00c9501b" },
        },
        [this.$t("total_items_count")]: {
          name: "users-icon",
          bgIcon: "#9810FA",
          color: "#fff",
          bgColor: { backgroundColor: "#ac46ff48" },
        },
      };

      return map[title];
    },

    getPercentColor(trend) {
      if (trend != null && trend == "increase") {
        return "#008236";
      }
      if (trend != null && trend == "decrease") {
        return "#C10007";
      }
      if (trend != null && trend == "none") {
        return "#a7a4a4ff";
      }
    },
    getPercentIcon(trend) {
      if (trend != null && trend == "increase") {
        return "mdi-arrow-top-right";
      }
      if (trend != null && trend == "decrease") {
        return "mdi-arrow-bottom-right";
      }
      if (trend != null && trend == "none") {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.stat-cards {
  width: 100%;
  border-radius: 12px !important;
  border: 1px solid #f3f4f6;
  backdrop-filter: blur(5px);
}
</style>
